import React from 'react'
import { A } from '@rebrandly/styleguide'
import Link from './../anchor'

import './Footer.css'

const Footer = () => (
  <div className='Footer'>
    <div className='Footer__container container m-t-64 m-b-64'>
      <div className='Footer__logo m-b-64'>
        <A className='Footer__link m-b-0' href='https://rebrandly.com' target='_blank'>Powered by <img src='/images/url-shortener.svg' alt='Url shortener' title='Url shortener' className='logo-header' width={110} height={28}/></A>
      </div>
      <div className='Footer__links-container'>
        <div className='Footer__column'>
          <A
            href='https://blog.rebrandly.com/what-is-a-branded-link'
            target='_blank'
            className='Footer__link'
          >
            What is a branded link
          </A>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/360007189533-utm-builder'
            target='_blank'
            className='Footer__link'
          >
            UTM builder
          </A>
          <A
            href='https://blog.rebrandly.com/what-is-link-retargeting/'
            target='_blank'
            className='Footer__link'
          >
            Link retargeting
          </A>
          <A
            href='https://rebrandly.com'
            target='_blank'
            className='Footer__link'
          >
            Link shortener
          </A>
        </div>
        <div className='Footer__column'>
          <A
            href='https://clickmeter.com'
            target='_blank'
            className='Footer__link'
          >
            Link tracking
          </A>
          <A
            href='https://free-url-shortener.rb.gy/'
            className='Footer__link'
          >
            Free URL shortener
          </A>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/227131707-Bitly'
            target='_blank'
            className='Footer__link'
          >
            Bitly URL shortener
          </A>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/227132547-TinyURL'
            target='_blank'
            className='Footer__link'
          >
            TinyURL alternative
          </A>
        </div>
        <div className='Footer__column'>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/115003864474-YouTube-URL-Shortener-'
            target='_blank'
            className='Footer__link'
          >
            Youtube URL shortener
          </A>
          <A
            href='https://rebrandly.com'
            target='_blank'
            className='Footer__link'
          >
            Custom short urls
          </A>
          <A
            href='https://blog.rebrandly.com/vanity-url/'
            target='_blank'
            className='Footer__link'
          >
            Vanity URL
          </A>
          <A
            href='https://blog.rebrandly.com/150-best-marketing-tools'
            target='_blank'
            className='Footer__link'
          >
            Marketing tools
          </A>
        </div>
        <div className='Footer__column'>
          <A
            href='https://blog.rebrandly.com/the-6-best-url-shorteners-and-how-to-choose-the-right-one-for-you/'
            target='_blank'
            className='Footer__link'
          >
            Best URL shorteners
          </A>
          <A href='https://rebrandly.com/sms' target='_blank' className='Footer__link'>
            SMS links
          </A>
          <A
            href='https://blog.rebrandly.com/crafting-perfect-twitter-bio-profile/'
            target='_blank'
            className='Footer__link'
          >
            Twitter bio link
          </A>
          <A
            href='https://blog.rebrandly.com/link-management'
            target='_blank'
            className='Footer__link'
          >
            Link management
          </A>
        </div>
        <div className='Footer__column'>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/221598367-Edit-and-Brand-%20Instagram-Bio-Link'
            target='_blank'
            className='Footer__link'
          >
            Instagram bio URL
          </A>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/115006602668-How-to-Create-a-QR-Code-from-your-Short-Link'
            target='_blank'
            className='Footer__link'
          >
            Create QR codes
          </A>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/227131707-Bitly'
            target='_blank'
            className='Footer__link'
          >
            Bitly alternative
          </A>
          <A
            href='https://blog.rebrandly.com/best-marketing-blogs'
            target='_blank'
            className='Footer__link'
          >
            Marketing blogs
          </A>
        </div>
        <div className='Footer__column'>
          <A
            href='https://rebrandly.com'
            target='_blank'
            className='Footer__link'
          >
            URL shortener
          </A>
          <A
            href='https://blog.rebrandly.com/google-url-shortener/'
            target='_blank'
            className='Footer__link'
          >
            Goo.gl
          </A>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/227132207-bitly-enterprise'
            target='_blank'
            className='Footer__link'
          >
            Bitly enterprise alternative
          </A>
          <A
            href='https://support.rebrandly.com/hc/en-us/articles/360001951033-migrate-short-urls'
            target='_blank'
            className='Footer__link'
          >
            Migrate short URLs
          </A>
        </div>
      </div>
    </div>
  </div>
)

export default Footer
